module.exports = __webpack_public_path__ + "static/img/7w.0305a51b.png";